export default __webpack_public_path__ + "static/media/icon.bdc576aa.png";